module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.10228/img/screenshot-twitter.png"